import { z } from 'zod';
import { adminAuditFieldsSchema } from './IAdminAudit';

export const cleaningFeeSchema = adminAuditFieldsSchema.extend({
    id: z.number().default(-1),
    name: z.string().default(''),
    price: z.coerce.number().default(0.00),
});

export type ICleaningFee = z.infer<typeof cleaningFeeSchema>;
